module.exports = __webpack_public_path__ + "static/media/sketch-file-icon.8cdcc5d4.svg";